__turbopack_context__.v({
  "accent": "qXxwHW_accent",
  "content": "qXxwHW_content",
  "cta": "qXxwHW_cta",
  "ctaContainer": "qXxwHW_ctaContainer",
  "description": "qXxwHW_description",
  "footer": "qXxwHW_footer",
  "title": "qXxwHW_title",
});
